import { render } from "./ModalTicketsImplantacao.vue?vue&type=template&id=2dd7c690&scoped=true&ts=true"
import script from "./ModalTicketsImplantacao.vue?vue&type=script&lang=ts"
export * from "./ModalTicketsImplantacao.vue?vue&type=script&lang=ts"

import "./ModalTicketsImplantacao.vue?vue&type=style&index=0&id=2dd7c690&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd7c690"]])

export default __exports__